import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from './context/GlobalContext';
import haxios, { clearCachedData } from './lib/haxios';
import { successToast, errorToast } from './lib/helpers';

// Forced first-login / reset screen. Reached when a login returns
// must_reset (admin-issued temp password or a freshly created account).
// The backend skips the current-password check while must_reset is set,
// so we only collect the new password here.

const MIN_LEN = 8;

const ChangePassword = () => {
  const nav = useNavigate();
  const { uinfo } = useContext(GlobalContext);

  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e?.preventDefault();
    setErr('');
    if (pw.length < MIN_LEN) { setErr(`Password must be at least ${MIN_LEN} characters.`); return; }
    if (pw !== confirm) { setErr('Passwords do not match.'); return; }
    setBusy(true);
    try {
      await haxios.post('/auth/change-password', { newPassword: pw });
      successToast('Password updated');
      nav('/');
    } catch {
      errorToast('Could not update password');
      setErr('Could not update password. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  const signOut = () => {
    clearCachedData();
    localStorage.removeItem('rememberMe');
    localStorage.removeItem('rememberedUsername');
    localStorage.removeItem('rememberedPassword');
    nav('/login');
  };

  return (
    <div className="modal-overlay" style={{ alignItems: 'center' }}>
      <div className="modal-card" style={{ maxWidth: 440 }} onClick={e => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="label">Account</div>
            <div className="modal-title">Set a new password</div>
          </div>
        </div>
        <form onSubmit={submit}>
          <div style={{ padding: 18, display: 'grid', gap: 12 }}>
            <p className="page-sub" style={{ margin: 0 }}>
              {uinfo?.Name ? `Welcome, ${uinfo.Name}. ` : ''}
              Please choose a new password to finish setting up your account.
            </p>
            {err && <div className="login-error num">{err}</div>}
            <label className="login-field">
              <span className="label">New password</span>
              <div className="login-input-wrap">
                <input
                  type={show ? 'text' : 'password'}
                  value={pw}
                  onChange={e => setPw(e.target.value)}
                  autoFocus
                  autoComplete="new-password"
                  placeholder="At least 8 characters"
                />
              </div>
            </label>
            <label className="login-field">
              <span className="label">Confirm new password</span>
              <div className="login-input-wrap">
                <input
                  type={show ? 'text' : 'password'}
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  autoComplete="new-password"
                  placeholder="Re-enter password"
                />
              </div>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
              <input type="checkbox" checked={show} onChange={() => setShow(v => !v)} />
              <span>Show password</span>
            </label>
          </div>
          <div className="modal-foot">
            <button type="button" className="btn ghost" onClick={signOut}>Sign out</button>
            <div style={{ flex: 1 }} />
            <button type="submit" className="btn primary" disabled={busy}>
              {busy ? 'Saving…' : 'Save password →'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
